import { Skeleton, Stack } from '@mui/material';
import { useIsMobile } from '@/data/hooks/useIsMobile';

export const AccountFavoriteSkeleton = () => {
	const isMobile = useIsMobile();
	return (
		<>
			<Skeleton variant="text" width={250} height={43} />
			<Stack direction={isMobile ? 'column' : 'row'} spacing={0} paddingTop={'18px'}>
				<Stack>
					<Skeleton sx={{ marginRight: '18px' }} variant="rectangular" width={350} height={290} />
					<Skeleton variant="text" width={300} height={43} />
					<Skeleton variant="text" width={100} height={43} />
					<Skeleton variant="text" width={200} height={43} />
				</Stack>
				<Stack>
					<Skeleton sx={{ marginRight: '18px' }} variant="rectangular" width={350} height={290} />
					<Skeleton variant="text" width={300} height={43} />
					<Skeleton variant="text" width={100} height={43} />
					<Skeleton variant="text" width={200} height={43} />
				</Stack>
				<Stack>
					<Skeleton sx={{ marginRight: '18px' }} variant="rectangular" width={350} height={290} />
					<Skeleton variant="text" width={300} height={43} />
					<Skeleton variant="text" width={100} height={43} />
					<Skeleton variant="text" width={200} height={43} />
				</Stack>
			</Stack>
		</>
	);
};
